// extracted by mini-css-extract-plugin
module.exports = {"logo":"DafaultLayout_logo__2Le98","user":"DafaultLayout_user__hpA2T","overlay":"DafaultLayout_overlay__3pznz"};